import Navbar from "@/pages/home/components/Navbar";
import PageBanner from "@/pages/home/components/PageBanner";
import Returns from "@/pages/home/components/Returns";
import Footer from "@/pages/home/components/Footer";
import CmsPage from "@/components/cms/CmsPage";

export default function ReturnsPage() {
  return (
    <main className="w-full">
      <Navbar />
      <CmsPage slug="returns" path="/returns" fallbackSeo={{ title: "Returns | NOMADLIVINGS", description: "Strong revenue drivers and healthy hospitality demand deliver attractive, recurring annual returns from your villa asset." }}>
      <PageBanner
        eyebrow="Returns"
        title="Income &amp; Return"
        highlight="Potential"
        subtitle="Strong revenue drivers and healthy hospitality demand combine to deliver attractive, recurring annual returns from your villa asset."
        image="https://readdy.ai/api/search-image?query=Financial%20growth%20concept%20with%20rising%20charts%20overlaid%20on%20a%20luxury%20resort%20villa%20background%20at%20sunset%2C%20warm%20golden%20tones%2C%20coins%20and%20investment%20markers%2C%20hospitality%20real%20estate%20returns%20theme%2C%20high%20detail%2C%20professional%20photography&width=1800&height=900&seq=banner-returns-x2&orientation=landscape&nocache=true"
        imageAlt="Financial growth charts over luxury resort villa background"
        ctaLabel="Schedule a Site Visit"
        ctaTo="/contact"
      />
      <Returns />
      </CmsPage>
      <Footer />
    </main>
  );
}